<template>
    <v-row class="footer">
      <v-col cols="2"></v-col>
      <v-col cols="3">
        <v-row>
          <v-col cols="5">
            <h4 class="mb-4">Related</h4>
            <a class="link" target="_blank" href="https://openanolis.org/">OpenAnolis</a>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="5">
            <h4 class="mb-4">Get Involved</h4>
            <a class="link" href="https://github.com/alibaba/dragonwell8/issues/new/choose">Raise Issue</a>
            <a class="link"
               href="https://job.alibaba.com/zhaopin/position_detail.htm?positionCode=GP629427">Join Us</a>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="2"></v-col>
      <v-col cols="3">
        <v-row>
          <v-col cols="5">
            <v-row>
              <v-img :src="require('../assets/img/ding_qr.png')"></v-img>
            </v-row>
            <v-row>
              <span style="width: 100%" class="text-center">Dragonwell Dingtalk</span>
            </v-row>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="5">
            <v-row>
              <v-img :src="require('../assets/img/acn_qr.jpg')"></v-img>
            </v-row>
            <v-row>
              <span style="width: 100%" class="text-center">Alibaba cloud native</span>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="2">
      </v-col>
    </v-row>
</template>


<script>
export default {
  props: {
    source: String
  },
  data() {
    return {
      version: 'dw8',
      //edition: 'Extended',
      arch: 'x86_64',
      os: 'linux',
      windowsD: false,
      alpineD: true,
      release: [],
      v2p: { // version to product
        dw8: {
          version: '8.9.10',
          upstreamVersion: '',
          changeLog: 'https://github.com/alibaba/dragonwell8/wiki/Alibaba-Dragonwell8-Edition-Release-Notes',
          userGuide: 'https://github.com/alibaba/dragonwell8/wiki/Alibaba-Dragonwell8-User-Guide',
          releases: 'https://github.com/alibaba/dragonwell8/wiki/%E4%B8%8B%E8%BD%BD%E9%95%9C%E5%83%8F(Mirrors-for-download)'
        },
        dw11: {
          version: '11.0.13.9',
          upstreamVersion: '',
          changeLog: 'https://github.com/alibaba/dragonwell11/wiki/Alibaba-Dragonwell-11-Release-Notes',
          userGuide: 'https://github.com/alibaba/dragonwell11/wiki/Alibaba-Dragonwell-11-User-Guide',
          releases: 'https://github.com/alibaba/dragonwell11/wiki/%E4%B8%8B%E8%BD%BD%E9%95%9C%E5%83%8F(Mirrors-for-download)'
        },
        dw17: {
          version: '17.0.1.0.1+12',
          upstreamVersion: '',
          changeLog: 'https://github.com/alibaba/dragonwell17/wiki/Alibaba-Dragonwell-17-Release-Notes',
          userGuide: 'https://github.com/alibaba/dragonwell17/wiki/Alibaba-Dragonwell-17-User-Guide',
          releases: 'https://github.com/alibaba/dragonwell17/wiki/%E4%B8%8B%E8%BD%BD%E9%95%9C%E5%83%8F(Mirrors-for-download)'
        }
      },
      va2d: { // version & arch to download
        dw8: {
          x86_64: {
            linux: 'https://github.com/alibaba/dragonwell8/releases/download/dragonwell-8.9.10_jdk8u312-ga/Alibaba_Dragonwell_8.9.10_x64_linux.tar.gz',
            windows: 'https://github.com/alibaba/dragonwell8/releases/download/dragonwell-8.11.12_jdk8u332-ga/Alibaba_Dragonwell_8.11.12_x64_windows.zip'
          },
          aarch64: {
            linux: 'https://github.com/alibaba/dragonwell8/releases/download/dragonwell-8.9.10_jdk8u312-ga/Alibaba_Dragonwell_8.9.10_aarch64_linux.tar.gz'
          }
        },
        dw11: {
          x86_64: {
            linux: 'https://github.com/alibaba/dragonwell11/releases/download/dragonwell-11.0.12.7_jdk-11.0.12-ga/Alibaba_Dragonwell_11.0.12.7_x64_linux.tar.gz',
            "alpine-linux": 'https://github.com/alibaba/dragonwell11/releases/download/dragonwell-11.0.12.7_jdk-11.0.12-ga/Alibaba_Dragonwell_11.0.12.7_x64_alpine-linux.tar.gz',
            windows: 'https://github.com/alibaba/dragonwell11/releases/download/dragonwell-11.0.15.11_jdk-11.0.15-ga/Alibaba_Dragonwell_11.0.15.11.9_x64_windows.zip'
          },
          aarch64: {
            linux: "https://github.com/alibaba/dragonwell11/releases/download/dragonwell-11.0.12.7_jdk-11.0.12-ga/Alibaba_Dragonwell_11.0.12.7_aarch64_linux.tar.gz"
          }
        },
        dw17: {
          x86_64: {
            linux: 'https://github.com/alibaba/dragonwell11/releases/download/dragonwell-11.0.12.7_jdk-11.0.12-ga/Alibaba_Dragonwell_11.0.12.7_x64_linux.tar.gz',
            "alpine-linux": 'https://github.com/alibaba/dragonwell11/releases/download/dragonwell-11.0.12.7_jdk-11.0.12-ga/Alibaba_Dragonwell_11.0.12.7_x64_alpine-linux.tar.gz',
            windows: 'https://github.com/alibaba/dragonwell17/releases/download/dragonwell-17.0.3.0.3%2B7_jdk-17.0.3-ga/Alibaba_Dragonwell_17.0.3.0.3+7_x64_windows.zip'
          },
          aarch64: {
            linux: "https://github.com/alibaba/dragonwell11/releases/download/dragonwell-11.0.12.7_jdk-11.0.12-ga/Alibaba_Dragonwell_11.0.12.7_aarch64_linux.tar.gz"
          },
        }
      },
      shellCode: '$ java PingPong\n' +
          ' 12560 ms\n' +
          '\n' +
          ' $ java -XX:+UseWisp2 PingPong\n' +
          ' 1132 ms',
      javaCode: 'public static void main(String[] args) {\n' +
          '    BlockingQueue<> q1, q2; // = ...\n' +
          '    THREAD_POOL.submit(() -> pingpong(q2, q1));\n' +
          '    future = THREAD_POOL.submit(() -> pingpong(q1, q2));\n' +
          '    q1.put((byte) 1);\n' +
          '    System.out.println(future.get() + " ms");\n' +
          '}\n' +
          '\n' +
          'private static long pingpong(in, out) {\n' +
          '    long start = System.currentTimeMillis();\n' +
          '    for (int i = 0; i < 1_000_000; i++) \n        out.put(in.take());\n' +
          '    return System.currentTimeMillis() - start;\n' +
          '} '
    };
  },
};
</script>

<style>
.footer {
  background-color: #353f4c;
  color: white;
}

.footer .link {
  display: block;
  margin-right: 24px;
  margin-bottom: 10px;
  color: #b9b9b9;
  font-size: 14px;
  text-decoration: none;
}
</style>
